
import { Vue, Component, Prop } from "vue-property-decorator";
import { Project_Activity } from "@/generated/graphql";
import Badge from "@/components/common/BadgeNew.vue";
import BadgeColor from "@/entities/BadgeColor";
import moment from "moment";

declare module "vue/types/vue" {
  interface Vue {
    $moment: typeof moment;
  }
}

@Component({
  components: {
    Badge,
  },
  apollo: {},
})
export default class StatusBadge extends Vue {
  @Prop({ type: Object, required: true }) readonly activity!: Project_Activity;

  BadgeColor: typeof BadgeColor = BadgeColor;

  hasAssignne(activity): boolean {
    return Boolean(activity.contractor?.user);
  }
 isNoShow(activity): boolean {
  const currentTime = moment();
  let end_date =activity.end_date || activity.start_date;
  const hasNotCheckedInOrOut =
    activity.checkin_time === null &&
    activity.checkout_time === null;

  if (!hasNotCheckedInOrOut) return false;

  
  if (end_date) {
    const shiftEndDate = moment(end_date).endOf('day');
    if (currentTime.isAfter(shiftEndDate)) return true;
  }

  if (activity.end_time) {
    const shiftEndTime = moment(activity.end_time);
    if (currentTime.isAfter(shiftEndTime)) return true;
  }

  return false;
}
 isNoShowActive(activity): boolean {
  const currentTime = moment();
  let start_time = activity.start_time;
  const hasNotCheckedInOrOut = activity.checkin_time === null

  if (!hasNotCheckedInOrOut) return false;

  
  if (start_time) {
    const timePassed = currentTime.isAfter(start_time);
    if (timePassed) return true;
  }
  return false;
}

isFutureVisit(activity): boolean {
  if (!activity?.start_time) return false;
  const visitTime = this.$moment.utc(activity.start_time);
  const now = this.$moment(); // Current time
  return visitTime.isAfter(now); // True only if in future
}

  checkInStatus(activity): string {
    if (activity.checkin_status === 'OUTSIDE') {
      return "Wrong Location";
    }
    if (!activity.drafted && this.isNoShowActive(activity)) {
      return "No Show";
    }
    if (activity.accepted === false) {
      return "Declined"; // If the activity is rejected, return "Rejected"
    }
    if (activity.accepted === true && !activity.checkin_status && !activity.checkout_status && !activity.completed &&
      !activity.drafted &&
      !activity.cancelled) {
      return "Accepted";
    }
     if (activity.checkin_status === "LATE") {
      return "Late Clock-in"; // red
    }
    if (activity.checkin_status === "EARLY") {
      return "Early Clock-in"; // red
    }
    if (activity.checkin_status === "ON_TIME") {
      return "Clocked-in"; // red
    }
    return "Offered";
  }

  checkOutStatus(activity): string {
    if (activity.checkout_status === 'OUTSIDE' || activity.checkin_status === 'OUTSIDE') {
      return "Wrong Location";
    }
    if (activity.accepted === false) {
      return "Declined"; // If the activity is rejected, return "Rejected"
    }
   

    if (!activity.drafted && this.isNoShow(activity) && !activity.completed) {
      return null;
    }
   
    if (activity.checkout_status === "LATE") {
      return "Late Clock-out"                                // after this = late
    }
    if (activity.checkout_status === "EARLY") {
      return "Early Clock-out"; // red
    }
    if (activity.checkin_status === "LATE") {
      return "Late Clock-in"; // red
    }
    if (activity.checkin_status === "EARLY") {
      return "Early Clock-in"; // red
    }
    if((activity.checkout_status === "ON_TIME" && activity.checkin_status === "ON_TIME") || (this.isNoShow(activity) && activity.completed)) {
      return "Completed"; // green
    }
    return 'Completed';

  }

  checkInStatusColor(activity) {
    const status = this.checkInStatus(activity);
    switch (status) {
    
      case "Wrong Location":
      case "No Show":
      case "Declined":
      case "Late Clock-in":
      case "Early Clock-in":
        return BadgeColor.WARNING;
      case "Clocked-in":
        return BadgeColor.INFO;
        case "Accepted":
        return BadgeColor.SUCCESS;
      case "Offered":
        return BadgeColor.OFFERED;
      default:
        return BadgeColor.WARNING;
    }
  }

  checkOutStatusColor(activity) {
    const status = this.checkOutStatus(activity); // Call the checkInStatus method

    // Assign color based on the status
    switch (status) {
      case "No Show":
      case "Declined":  
      case "Wrong Location":
      case "Late Clock-out":
        return BadgeColor.WARNING;
      case "Clocked-out":
        return BadgeColor.INFO;
        case "Completed":
        return BadgeColor.INFO;
      default:
        return BadgeColor.WARNING;
    }
  }
  showIconForStatus(activity) {
    const status = this.checkInStatus(activity);
    switch (status) {
      case "Wrong Location":
      case "Late Clock-in":
      case "Early Clock-in":
        return true;
      case "Clocked-in":
        return false;
      default:
        return false;
    }
  }
  showIconForStatusCheckOut(activity) {
    const status = this.checkOutStatus(activity);
    switch (status) {
       case "Wrong Location":
        return true;
      case "Late Clock-out":
        return true;
      case "Early Clock-out":
        return true;
      case "Clocked-out":
        return false;
      default:
        return false;
    }
  }
  checkInStatusClass(activity) {
    const status = this.checkInStatus(activity); // Call the checkInStatus method

    switch (status) {
      case "Wrong Location":
      case "Late Clock-in":
      case "Early Clock-in":
        return "redPill";
      case "Clocked-in":
      case "Offered":
      case "Completed":
        return "text-badge .bg-lightBlue";
      default:
        return "text-badge bg-badge-active";
    }
  }
  checkOutStatusClass(activity) {
    const status = this.checkOutStatus(activity); // Call the checkInStatus method

    // Assign color based on the status
    switch (status) {
        case "Wrong Location":
      case "Late Clock-out":
      case "Early Clock-out":
        return "redPill";
      case "Clocked-out":
        case "Completed":
        return "text-badge bg-lightBlue";
      default:
        return "text-badge bg-badge-active";
    }
  }
}
